import http from '../../../Services/api.laravel.http';

export const AuthService = {
 	getUserDetails: () => http.get('/user/details'),
	resetPass: (formParams) => http.post('/user/reset-password', formParams),
    sendResetPass: (formParams) => http.post('/user/forgotpassword', formParams),
    register: (formParams) => http.post('/user/register', formParams),
    validate: () => http.get('/admin/verify/token')
}